import { APP_SHELL_WIDTH } from "@/components/ui/FixedFooter"
import { CHROME_Z_INDEX } from "@/contexts/ModalContext"
import { useBottomChromeSlot } from "@/hooks/use-bottom-chrome-slot"
import { cn } from "@/lib/cn"
import { ReactNode } from "react"

/**
 * Floating bottom container shared by the cart CTAs (FinishCartButton,
 * FloatingCartButton).
 *
 * Same two-element shape and width cap as FixedFooter, so the cart bar lines
 * up with the action footers instead of resolving its own horizontal position
 * — `m-auto` cannot center a fixed element with no inset, since `left` then
 * falls back to wherever the bar happens to sit in the tree.
 */
export function FixedBottomBar({
  className,
  children,
}: {
  className?: string
  children: ReactNode
}) {
  const measureRef = useBottomChromeSlot<HTMLDivElement>("cart-bar")

  return (
    <div
      ref={measureRef}
      style={{ zIndex: CHROME_Z_INDEX.cartBar }}
      className={cn(
        "fixed bottom-4 left-0 right-0 transition-[bottom,opacity] duration-slow ease-standard",
        className,
      )}
    >
      <div className={cn("mx-auto px-4", APP_SHELL_WIDTH)}>{children}</div>
    </div>
  )
}
